import React, { useState, useEffect, useContext } from 'react'
import { navigate } from 'gatsby'
import Button from '../../atoms/button/button'
import ButtonClose from '../../atoms/button-close/button-close'
import { siteUrl } from '../../../shared/utils/siteUrl'
import imgModalRedeem from '../../../assets/images/modal-redeem/all-fine-girl.png'
import imgSearchIcon from '../../../assets/images/modal-redeem/box-icon-search.png'

import useMediaQuery from '../../../utils/useMediaQuery'
import { pushEventData } from '../../../utils/pushEventDataLayer'

import Loader from 'react-loader-spinner'

import { costActivity, gameId } from '../../../constants/activity-constants'

import CompetitionService from '../../../shared-campaign/services/competition'
import gameServices from '../../../services/game-service'
import { Context } from '../../../context/app-context'
import AuthService from '../../../shared/services/auth-service'
import userSessionStorage from '../../../utils/userSessionStorage'

import './modalRedeem.scss'

const LOCALE = process.env.LOCALE;
const italatam = LOCALE === 'es-AR';
const ModalRedeem = props => {
  const { handleStartGame, close } = props

  const isMobile = useMediaQuery()

  const { dispatch } = useContext(Context)
  const [session] = useState(new userSessionStorage())
  const [pointsUser, setPointsUser] = useState('')
  const [nameUser, setNameUser] = useState('')

  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingPoints, setIsLoadingPoints] = useState(false)

  const [errorMessageKeys, setErrorMessageKeys] = useState(false)
  const [errorMessageRedeem, setErrorMessageRedeem] = useState(false)

  const [requested, setHaveRequested] = useState(false)
  const [haveToken, setHaveToken] = useState(false)

  const [myKey, setMyKey] = useState('')

  // load user info
  useEffect(() => {
    let userInfo = JSON.parse(localStorage.getItem('USER_INFO'))
    if (userInfo) {
      setNameUser(userInfo.name.split(' ')[0])

      let tokenId = session.getToken().idToken
      let config = {
        headers: {
          Authorization: tokenId,
        },
      }
      AuthService.sessionInfo(config).then(res => {
        if (res.status === 200) {
          setPointsUser(
            res.data.userPoints.pointsAccumulation +
            res.data.userPoints.pointsPresent
          )
        } else {
          setPointsUser(
            userInfo.userPoints.pointsAccumulation +
            userInfo.userPoints.pointsPresent
          )
        }
      })
    } else {
      navigate('/')
    }
  }, [])

  const handleErrorMessage = (set, message) => {
    set === 'errorkeys'
      ? setErrorMessageKeys(message)
      : setErrorMessageRedeem(message)
    setTimeout(() => {
      setErrorMessageKeys('')
      setErrorMessageRedeem('')
    }, 6000)
  }

  const handleRedimir = isTokenActivo => {

    if (isLoading) {
      return
    }
    if(costActivity<=0){
      reedemSuccess();
      return
    }
    setIsLoading(true)
    setErrorMessageRedeem(false)
    let points = pointsUser
    if (points < costActivity && haveToken) {
      handleErrorMessage('errorRedeem', 'No hay suficientes puntos.')
      setIsLoading(false)
      return
    }
    let tokenId = session.getToken().idToken
    let config = {
      headers: {
        Authorization: tokenId,
      },
    }
    try {
      gameServices.getTokenGame(gameId, config).then(res => {
        if (res.status === 200) {
          pushEventData({
            event: isTokenActivo ? 'Token activo' : 'Redimir puntos',
            action: isTokenActivo ? 'click juego' : 'click redimir',
            label: isTokenActivo ? 'jugar' : 'quiero redimir y jugar'
          })

          sessionStorage.setItem('tokenParticipation', res.data.tokenGame)
          setIsLoading(false)
          reedemSuccess()
        } else if (res.status === 400) {
          gameServices.postGameParticipationRedeem(gameId, config).then(res => {
            if (res.status === 200) {
              // pushEventDataLayer(
              //   isTokenActivo
              //     ? 'Interacciones - Token activo'
              //     : 'Interacciones - Redimir puntos',
              //   'busca-palabras',
              //   'click redimir',
              //   isTokenActivo ? 'jugar' : 'quiero redimir y jugar'
              // )

              sessionStorage.setItem('tokenParticipation', res.data.tokenGame)
              setIsLoading(false)
              reedemSuccess()
            } else {
              handleErrorMessage('errorRedeem', res.userMessage)
              setIsLoading(false)
            }
          })
        } else {
          handleErrorMessage('errorRedeem', res.userMessage)
          setIsLoading(false)
        }
      })
    } catch (error) {
      console.log(error)
      handleErrorMessage(
        'errorRedeem',
        'Algo ha salido mal con la petición, inténtalo de nuevo'
      )
      setIsLoading(false)
    }
  }

  useEffect(() => {
    let tokenId = session.getToken().idToken
    let config = {
      headers: {
        Authorization: tokenId,
      },
    }
    try {
      gameServices.getTokenGame(gameId, config).then(res => {
        setHaveRequested(true);
        if (res.status === 200) {
          setHaveToken(false)
        } else {
          setHaveToken(true)
        }
      })
    } catch (error) {
      console.log(error)
      setHaveToken(true)
    }
  }, [])



  const handleUpdateData = () => {
    dispatch({
      type: 'set',
      payload: {
        modalActive: {
          type: `updateData`,
          props: {
            success: () => handleStartGame(),
            close: () => {
              navigate('/')
              dispatch({
                type: 'set',
                payload: {
                  modalActive: null,
                },
              })
            },
          },
        },
      },
    })
  }

  const reedemSuccess = () => {
    // actulizar datos si corresponde
    let updateDAta = JSON.parse(localStorage.getItem('UPDATE_DATA_ACTIVITY'))
    const userInfo = JSON.parse(localStorage.getItem('USER_INFO')).email

    const isUpdateData =
      updateDAta &&
      updateDAta.some(item => {
        return item.email === userInfo && item.activityId === gameId
      })

    if (isUpdateData) {
      handleStartGame()
    } else {
      handleUpdateData()
    }
  }

  const handleAquirePoints = async (e) => {

    if (isLoadingPoints) {
      return null;
    }
    e.preventDefault()
    // pushEventDataLayer('Personajes :: Juego', 'Click :: Enviar Clave', 'ENVIAR')
    pushEventData({
      event: 'Registro Claves',
      action: 'click claves',
      label: 'Enviar'
    })
    if (myKey === '') {
      handleErrorMessage('errorkeys', 'Ingresa primero una clave')
    } else {
      setIsLoadingPoints(true)
      setErrorMessageKeys(false)
      let redeemRes = await CompetitionService.postRedeemKeyWithoutPoints(0, {
        activity: 'curv-boom',
        key: { code: myKey },
        country: parseInt(process.env.COUNTRY_CODE),
      })
      if (redeemRes.status === 200) {
        // pushEventDataLayer(
        //   'Interacciones - Registro claves',
        //   'busca-palabras',
        //   'click redimir',
        //   'enviar'
        // )
        setIsLoadingPoints(false)
        setPointsUser(points => points + redeemRes.data.points)
        setMyKey('')
      } else {
        handleErrorMessage('errorkeys', redeemRes.userMessage)
        setIsLoadingPoints(false)
      }
    }
  }

  const formatNumber = number => {
    if (number === '0') return 0
    if (number) return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return 0
  }

  const puntosRombo = (points) => {
    return <span className="f-romboPuntosRedeem">
      <b className="f-romboPuntosRedeem__numero">
        {formatNumber(points)}
      </b>
    </span>;
  }
  const greetingsAndPoints = (<div className={"f-modalRedeem-container__greetings " + (isMobile && "--absolute")}>
    <h2>
      ¡Hola!   <br />{nameUser.toUpperCase()}, {italatam ? 'tenés' : 'tienes'}
    </h2>
    {puntosRombo(pointsUser)}

  </div>);

  const redimeView = LOCALE === 'es-BO' ? (
    <>
      <div className={"--center-text"}>
        <h2 className='--pink-text'>
          ¡Hola!<br />{nameUser.toUpperCase()}
        </h2>
      </div>
      <p className="f-textTokenActive --pink-text">
        ¿Estás lista para aprender más sobre tu Zona V?
      </p>
      <p className="f-modalRedeem-container__infoRedeem__setKeys__textInfoKeys">
        Encuentra las palabras escondidas,
        <br />¡coooorre que el tiempo es oro!
      </p>
      <br />
      <Button
        disabled={isLoading}
        loading={isLoading}
        onClick={() => {
          handleRedimir(true)
        }}
      >
        !Vamos!
      </Button>
      {errorMessageRedeem && (
        <span className="f-errorMessage">{errorMessageRedeem}</span>
      )}
    </>
  )
    : (
      <>
        <p className="f-textRedimir">
          <b>¿Estás lista para {italatam?'canjear':'redimir'}</b>
          <br />
          {puntosRombo(costActivity)}
          y comenzar a jugar?
        </p>
        <b className="f-textOportu">
          1 oportunidad = {costActivity} puntos
        </b>
        <Button
          className="f-buttonActivity btnRedimir"
          disabled={isLoading}
          loading={isLoading}
          onClick={() => {
            handleRedimir(false)
          }}>
          Quiero redimir y jugar
        </Button>
        {errorMessageRedeem && (
          <span className="f-errorMessage">{errorMessageRedeem}</span>
        )}
        <div className="f-modalRedeem-container__infoRedeem__setKeys">
          <p className="f-modalRedeem-container__infoRedeem__setKeys__textInfoKeys">
            <span> ¿No {italatam?'tenés':'tienes'} puntos para redimir?</span> 
            <br />
            Inscribe {italatam?'acá':'aquí'} las claves de tus productos 
            <br /> 
            Nosotras y {italatam?'acumulá':'acumula'} puntos para jugar.
          </p>
          <div className="f-modalRedeem-container__infoRedeem__setKeys__inputAndButton">
            <input
              placeholder="Digita Tus Claves"
              value={myKey}
              onChange={e => {
                setMyKey(e.target.value)
              }}
            />
            <Button
              className="f-buttonActivity --right"
              disabled={isLoadingPoints}
              loading={isLoadingPoints}
              onClick={(e) => handleAquirePoints(e)}>
              Enviar
            </Button>
          </div>
          {errorMessageKeys && (
            <p className="f-errorMessage">{errorMessageKeys}</p>
          )}
          <a target='_BLANK' href={siteUrl + "/mis-puntos/ingreso-de-claves/"}>Quiero saber cómo {isMobile && <br />}ingresar mis claves</a>
        </div>
      </>
    );



  const displayView =
    haveToken ? redimeView : (
      <>

        <figure className="f-modalRedeem-container__figure-redimee">
          <img src={imgSearchIcon} title='Icono lupa grande' className="f-modalRedeem-container__image_redimee"></img>
        </figure>

        <p className="f-textTokenActive">
          <span> ¿Te saliste en la mitad del juego? </span>
          <br /> ¡Tranquila! {italatam?'podés':'puedes'} seguir jugando sin {italatam?'canjear':'redimir'} más puntos
        </p>
        <Button
          disabled={isLoading}
          loading={isLoading}
          onClick={() => {
            handleRedimir(true)
          }}
        >
          Jugar
        </Button>
        {errorMessageRedeem && (
          <span className="f-errorMessage">{errorMessageRedeem}</span>
        )}
      </>
    );


  return (
    <div className="f-modalRedeem-container">
      <div className="f-modalRedeem-container__wrapper">
        <ButtonClose onClick={close} />
        {!isMobile && (
          <figure className='f-modalRedeem-container__figure --bigleft'>
            {LOCALE !== 'es-BO' && greetingsAndPoints}
            <img className='f-modalRedeem-container__image' src={imgModalRedeem} alt="chicas reunidas en el login" />
          </figure>
        )}
        <section className="f-modalRedeem-container__infoRedeem">
          {isMobile && LOCALE !== 'es-BO' && greetingsAndPoints}
          {requested && displayView}
          {!requested && (<Loader type="Oval" color="#FA3B88" height={50} width={50} />)}
        </section>
      </div>
    </div>
  )
}

export default ModalRedeem
